import React, { useEffect, useState } from 'react';
import SearchRow from 'components/SearchRow/SearchRow';
import { get } from 'lib/comms';
import Table from 'components/Table/Table';
import WorshipLocationPage from './WorshipLocationPage';
import moment from 'moment';
import { Navigate } from 'react-router-dom';

const WorshipLocationsPage = (props) => {
    const [state, setState] = useState({
        data: [],
        search: '',
        activeTab: null,
        editing: null,
        stepIndex: 0,
    });

    const columns = [
        {
            name: 'title',
            selector: (row) => row.title,
            sortable: true,
            grow: 3,
            wrap: true,
        },
        {
            name: 'Description',
            selector: (row) => row.description,
            sortable: true,
            grow: 3,
            wrap: true,
        },
        {
            name: 'Location',
            selector: (row) => row.location,
            sortable: true,
            grow: 3,
            wrap: true,
        },
        {
            name: 'Created At',
            selector: (row) => row.created_at,
            sortable: true,
            format: (row) => (row.created_at ? moment(row.created_at).format('DD MMM YYYY') : ''),
        },
        {
            name: 'Status',
            selector: (row) => row.active,
            sortable: true,
            center: true,
            format: (row) => (row.created_at ? (row.active ? 'Active' : 'Archived') : 'Not posted'),
        },
    ];

    const updateItemCreated = () => {
        setState({ ...state, createdNew: true });
    };

    const doneEditing = () => {
        setState({ ...state, editing: null });
    };

    const reload = async (type) => {
        let resp = await get('cms/worship_locations', null, true);
        if (resp && resp.status === 401) setState({ ...state, logout: true });
        if (resp && resp.worshipLocations) {
            if (type === 'back') {
                setState({ ...state, data: resp.worshipLocations, editing: null });
            } else {
                setState({ ...state, data: resp.worshipLocations });
            }
        } else console.log(resp);
    };

    useEffect(() => {
        reload();
    }, [setState]);

    if (state.logout) return <Navigate to={{ pathname: '/logout', state: { from: props.location } }} />;

    let { data, search, editing } = state;
    if (search) {
        data = data.filter((item) => `${item.title}${item.location}`.toLowerCase().indexOf(search.toLowerCase()) >= 0);
    }

    return (
        <>
            {state.editing ? (
                <WorshipLocationPage
                    worship={editing}
                    onBack={doneEditing}
                    updateItemCreated={updateItemCreated}
                    activeTab={state.activeTab}
                    reload={reload}
                />
            ) : (
                <div className="maincontainer">
                    <h4>Worship Locations</h4>
                    <SearchRow
                        value={search}
                        searchTitle="Search by title of worship location"
                        onSearch={(search) => setState({ ...state, search })}
                        buttonTitle="ADD NEW WORSHIP LOCATION"
                        onBtnClick={(item) => setState({ ...state, editing: { id: 'new' } })}
                    />
                    <Table
                        columns={columns}
                        data={data}
                        onRowClicked={(item) => setState({ ...state, editing: item, activeTab: null })}
                        tableID="worshipLocation"
                        defaultSortField={columns[1].selector}
                    />
                </div>
            )}
        </>
    );
};

export default WorshipLocationsPage;
